//import { Utils } from "../../shared/utils";
//import moment from "moment";
class SearchUtils {

	doSearch = (searchTerm, srcCrit, searchIndex) => {
		searchTerm = this.sanitizeInput(searchTerm);
		
		let searchResults = [];

		let cnt1 = 0;
		let cnt2 = 0;
		let cnt3 = 0;

		let pgKeyWds = "";
		let pgTitle = "";
		let pgUrl = "";
		let pgAuthor = "";
		let pgDate = "";
		let pgPostType = "";
		let descripStr = "";
		let refineAllString = "";
		let descripStrArray = [];
		let descStrArrItems = 0;
		let occurNum = 0;
		let beginPhrase = 0;
		let matchesPerTerm = 0;
		let totalMatches = 0;
		let startPos = 0;
		let endPos = 0;
		let searchArray = [];
		let myRE = new RegExp();
		let regExPattern = "";
		let matchAllResult = {};
		let matchResults = [];
		let allConfirmation = true;
		let atBegin = false;
		let atEnd = false;
		let myBriefDescrip = {};
		let anyWordSearchTerms = [];
		let allWordSearchTerms = [];
		const stopwords = new Set(['a', 'an', 'and', 'are', 'by', 'for', 'is', 'in', 'it', 'its', 'of', 'on', 'the', 'to', 'with', '&']);
		if (!srcCrit) {
			srcCrit = "any";
		}
		if (!(searchTerm == null)) {
			for (cnt1 = 0; cnt1 < searchIndex.length; cnt1++) {
				occurNum = 0;
				matchesPerTerm = 0;
				descStrArrItems = 0;
				descripStrArray = [];
				pgTitle = searchIndex[cnt1].title;
				pgUrl = searchIndex[cnt1].link;
				refineAllString = this.mergeStrings([pgTitle, searchIndex[cnt1].content]);
				pgKeyWds = searchIndex[cnt1].keywords;
				pgAuthor = searchIndex[cnt1].author;
				pgDate = searchIndex[cnt1].date;
				pgPostType = searchIndex[cnt1].postType;
				descripStr = "";
				switch (srcCrit) {
					case "all":
						allConfirmation = true;
						searchArray = searchTerm.split(" ");
						allWordSearchTerms = [];
						// strip out stopwords and duplicate words
						searchArray = Array.from(new Set(searchArray.filter(x => !stopwords.has(x.toLowerCase()))));
						// determine how many terms get a phrase in the description
						if ((4 / searchArray.length) > 0) {
								matchesPerTerm = (4 / searchArray.length);
						} else {
								matchesPerTerm = 1;
						}
						for (cnt2 = 0; cnt2 < searchArray.length; cnt2++) {
							totalMatches = 0;
							regExPattern = this.escapeRegExp(searchArray[cnt2].trim());
							//regExPattern = searchArray[cnt2].trim();
							allWordSearchTerms.push(regExPattern);
							myRE = new RegExp(regExPattern, "gi");
							matchAllResult = this.mergeStrings([refineAllString, pgKeyWds, pgAuthor]).matchAll(myRE);
							matchResults = Array.from(matchAllResult);
							//console.log(matchResults)
							if (matchResults?.length > 0) {
								beginPhrase = 0;
								for (cnt3 = 0; cnt3 < matchResults.length; cnt3++) {
									occurNum++;
									if (((totalMatches < matchesPerTerm) && (descripStrArray.length < 4))) {
										beginPhrase = matchResults[cnt3].index;
										if (this.noPreviousOccur(descripStrArray, beginPhrase, refineAllString)) {
											// get text 'phrase' that contains search term
											let resultPhrase = this.makeResultPhrase(beginPhrase, regExPattern, refineAllString);
											if (resultPhrase) {
												startPos = resultPhrase.startPos;
												endPos = resultPhrase.endPos;
												atBegin = resultPhrase.atBegin;
												atEnd = resultPhrase.atEnd;
												myBriefDescrip = this.makeBriefDescrip(startPos, endPos, beginPhrase, refineAllString.substring(startPos, endPos), atBegin, atEnd);
												descripStrArray.push(myBriefDescrip);
												descStrArrItems++;
											}
											totalMatches++;
										}
									}
								} //end cnt3
													
							} else {
								allConfirmation = false;
								break;
							}
						} //end cnt2 loop

						if (allConfirmation) {
							// build brief description
							descripStr = "";
							descripStrArray.forEach((dscrip, index) => {
								descripStr += dscrip.termTxt + "…";
							});
							// hilite search terms in brief description
							allWordSearchTerms.forEach((term, index) => {
								descripStr = this.hiliteTerm(descripStr, term);
								pgAuthor = this.hiliteTerm(pgAuthor, term);
							});
							let thisSearchResult = this.buildSearchResult(occurNum, pgTitle, pgAuthor, pgDate, descripStr, pgUrl, pgPostType);
							searchResults.push(thisSearchResult);
							matchResults = Array.from(matchAllResult);
						}
						break;
						case "phrase":
							totalMatches = 0;
							matchesPerTerm = 4;
							regExPattern = "\\b(" + this.escapeRegExp(searchTerm) + ")\\b";
							//regExPattern = this.escapeRegExp(searchTerm);
							myRE = new RegExp(regExPattern, "gi");
							matchAllResult = this.mergeStrings([refineAllString, pgKeyWds, pgAuthor]).matchAll(myRE);
							matchResults = Array.from(matchAllResult);
							//console.log("regExPattern:" + regExPattern + ", matchResults.length: " + matchResults.length)
							if (matchResults?.length > 0) {
								beginPhrase = 0;
								for (cnt2 = 0; cnt2 < matchResults.length; cnt2++) {
									occurNum++;
									if (((totalMatches < matchesPerTerm) && (descripStrArray.length < 4))) {
										beginPhrase = matchResults[cnt3].index;
										if (this.noPreviousOccur(descripStrArray, beginPhrase, refineAllString)) {
											// get text ''phrase' that contains search term
											let resultPhrase = this.makeResultPhrase(beginPhrase, regExPattern, refineAllString);
											if (resultPhrase) {
												startPos = resultPhrase.startPos;
												endPos = resultPhrase.endPos;
												atBegin = resultPhrase.atBegin;
												atEnd = resultPhrase.atEnd;
												myBriefDescrip = this.makeBriefDescrip(startPos, endPos, beginPhrase, refineAllString.substring(startPos, endPos), atBegin, atEnd);
												descripStrArray.push(myBriefDescrip);
												descStrArrItems++;
											}
											totalMatches++;
										}
									}

								} //end cnt2

							}
							if (occurNum > 0) {
								// build brief description
								descripStr = "";
								descripStrArray.forEach((dscrip, index) => {
									descripStr += dscrip.termTxt + "…";
								});
								// hilite search terms in brief description
								descripStr = this.hiliteTerm(descripStr, searchTerm);
								pgAuthor = this.hiliteTerm(pgAuthor, searchTerm);
								let thisSearchResult = this.buildSearchResult(occurNum, pgTitle, pgAuthor, pgDate, descripStr, pgUrl, pgPostType);
								searchResults.push(thisSearchResult);
							}

						break;
						default:
							searchArray = searchTerm.split(" ");
							anyWordSearchTerms = [];
							// strip out stopwords and duplicate words
							searchArray = Array.from(new Set(searchArray.filter(x => !stopwords.has(x.toLowerCase()))));

							if ((4 / searchArray.length) > 0) {
								matchesPerTerm = (4 / searchArray.length);
							} else {
								matchesPerTerm = 1;
							}
							for (cnt2 = 0; cnt2 < searchArray.length; cnt2++) {
								// reset to zero for every new word
								totalMatches = 0;
								regExPattern = this.escapeRegExp(searchArray[cnt2].trim());
								//regExPattern = this.escapeRegExp(regExPattern);
								anyWordSearchTerms.push(regExPattern);
								myRE = new RegExp(regExPattern, "gi");
								matchAllResult = this.mergeStrings([refineAllString, pgKeyWds, pgAuthor]).matchAll(myRE);
								matchResults = Array.from(matchAllResult);
								if (matchResults?.length > 0) {
									beginPhrase = 0;
									for (cnt3 = 0; cnt3 < matchResults.length; cnt3++) {
										occurNum++;
										if (((totalMatches < matchesPerTerm) && (descripStrArray.length < 4))) {
											beginPhrase = matchResults[cnt3].index;
											if (this.noPreviousOccur(descripStrArray, beginPhrase, refineAllString)) {
												// get text 'phrase' that contains search term
												let resultPhrase = this.makeResultPhrase(beginPhrase, regExPattern, refineAllString);
												if (resultPhrase) {
													startPos = resultPhrase.startPos;
													endPos = resultPhrase.endPos;
													atBegin = resultPhrase.atBegin;
													atEnd = resultPhrase.atEnd;
													myBriefDescrip = this.makeBriefDescrip(startPos, endPos, beginPhrase, refineAllString.substring(startPos, endPos), atBegin, atEnd);
													descripStrArray.push(myBriefDescrip);
													descStrArrItems++;
												}
												totalMatches++;
											}
										}
									} //end cnt3
								}

							} //end cnt2
							if (occurNum > 0) {
								// build brief description
								descripStr = "";
								descripStrArray.forEach((dscrip, index) => {
									descripStr += dscrip.termTxt + "…";
								});
								// hilite search terms in brief description
								anyWordSearchTerms.forEach((term, index) => {
									descripStr = this.hiliteTerm(descripStr, term);
									pgAuthor = this.hiliteTerm(pgAuthor, term);
								});
								let thisSearchResult = this.buildSearchResult(occurNum, pgTitle, pgAuthor, pgDate, descripStr, pgUrl, pgPostType);
								searchResults.push(thisSearchResult);
							}

				}
			}

		}
		if (searchResults?.length > 0) {
			searchResults = searchResults.sort((a, b) => b.hits - a.hits);
		}
		return searchResults;

	}

	makeResultPhrase = (termPosition, termStr, contentStr) => {
		let startPos = 0;
		let endPos = 0;
		let atBegin = false;
		let atEnd = false;
		// is substring beginning of contentStr?
		if ((termPosition - 45) > 0) {
			startPos = (termPosition - 45);
			atBegin = false;
		} else {
			startPos = 0;
			atBegin = true;
		}

		// is substring end of contentStr?
		if ((termPosition + (termStr.length + 45)) < contentStr.length) {
			endPos = (termPosition + (termStr.length + 45 + 1));
			atEnd = false;
		} else {
			endPos = contentStr.length;
			atEnd = true;
		}

		return {
			startPos: startPos,
			atBegin: atBegin,
			endPos: endPos,
			atEnd: atEnd
		}
	}

	mergeStrings = (strArray) => {
		let mergeString = "";
		strArray.forEach((str, index) => {
			if (str) {
				mergeString += " " + str;
			}
		});
		mergeString = mergeString.replace(/  +/g, ' ').trim();
		return mergeString;
	}

	makeBriefDescrip = (posStart, posEnd, posTerm, termStr, isBegin, isEnd) => {
		//console.log("termStr:" + termStr)
		let returnBDItem = {};
		let subStrStart = 0;
		let subStrEnd = 0;
		let subStrLen = 0;
		let termStrStart = 0;
		let termStrEnd = 0;
		let termPos = 0;
		let termTxt = "";
		if (isBegin) {
			subStrStart = 0;
		} else {
			subStrStart = termStr.indexOf(" ");
		}

		if (isEnd) {
			//subStrLen = ((termStr.length - subStrStart) + 1);
			subStrLen = termStr.length;
		} else {
			subStrLen = (termStr.lastIndexOf(" ") - subStrStart);
		}

		termTxt = termStr.substring(subStrStart, subStrLen);
		termStrStart = (posStart + subStrStart);
		termStrEnd = (termStrStart + termTxt.length);
		termPos = (posTerm - subStrStart);
		returnBDItem.posStart = termStrStart;
		returnBDItem.posEnd = termStrEnd;
		returnBDItem.posTerm = termPos;
		returnBDItem.termTxt = termTxt.trim();
		return returnBDItem;
	}

	noPreviousOccur(briefDescripArray, thisIndex, refineAllString) {
		let returnBool = true;
		if ((thisIndex > refineAllString.length)) {
			returnBool = false;
		} else {
			// if thisIndex is contained in an existing substring return false
			for (let x = 0; x < briefDescripArray.length; x++) {
				if (((thisIndex > briefDescripArray[x].posStart) && (thisIndex < briefDescripArray[x].posEnd))) {
					returnBool = false;
					break;
				}
			}
		}
		return returnBool;
	}

	buildSearchResult(refNum, pgTitle, pgAuthor, pgDate, descripStr, pgUrl, pgPostType) {
		let searchResult = {
			hits: refNum,
			title: pgTitle,
			author: pgAuthor,
			date: pgDate,
			description: descripStr,
			url: pgUrl,
			postType: pgPostType,
		}
		return searchResult;
	}

	hiliteTerm = (input, term) => {
		return input.replace(new RegExp('(^|)(' + term + ')(|$)', 'ig'), '$1<b>$2</b>$3');
	}

	stripHtml = (htmlStr) => {
		var SCRIPT_REGEX = /<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi;
		while (SCRIPT_REGEX.test(htmlStr)) {
			htmlStr = htmlStr.replace(SCRIPT_REGEX, " ");
		}
		var HTMREGEX = /(<([^>]+)>)/ig;
		htmlStr = htmlStr.replace(HTMREGEX, " ");
		var ENTITYREGEX = /(&#[0-9]*;)/ig
		htmlStr = htmlStr.replace(ENTITYREGEX, " ");
		htmlStr = htmlStr.replace(/&nbsp;/g, ' ');
		htmlStr = htmlStr.replace(/&rsquo;/g, '\'');
		htmlStr = htmlStr.replace(/&lsquo;/g, '\'');
		htmlStr = htmlStr.replace(/&ldquo;/g, '\'');
		htmlStr = htmlStr.replace(/&rdquo;/g, '\'');
		htmlStr = htmlStr.replace(/&ndash;/g, '-');
		htmlStr = htmlStr.replace(/&mdash;/g, '-');
		htmlStr = htmlStr.replace(/&amp;/g, '&');
		htmlStr = htmlStr.replace(/\\\"/g, '\'');
		htmlStr = htmlStr.replace(/  +/g, ' ');
		htmlStr = htmlStr.replace(/ \./g, '.');
		htmlStr = htmlStr.replace(/ \,/g, '.').trim();
		return htmlStr;
	};

	deepClone = (data) => {
		return JSON.parse(JSON.stringify(data)) || [];
	}

	escapeRegExp = (text) => {
		return text.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');
	}

	sanitizeInput = (input) => {
		if (input !== "") {
			input = input.replace(/  +/g, ' ');
			return input.replace(/[^\w #'+,.@&áéíñóúü-]/gim, '').trim();
		} else {
			return input;
		}
	}

}

export const searchUtils = new SearchUtils();